import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import ecprimeLogo from '../atoms/data/ec-prime-logo.svg';

class HeaderAdmin extends Component {
    onClickLogout = (e) => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'Logout_Saga',
            onSuccess: this.onSuccessLogout,
            onFailure: this.onFailureLogout,
        });
    }
    onSuccessLogout = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: 'Logout',
        });
        this.props.history.push('/admin');
    }
    onFailureLogout = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    render(){
        return(
            <Body>
                <Logo src={ecprimeLogo}/>
                <Title>
                    {this.props.title}
                </Title>
                <Button onClick={this.onClickLogout}>
                    <i className="fas fa-sign-out-alt" />
                    ログアウト
                </Button>
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
    }
};

const connectedHeaderAdmin = connect(mapStateToProps)(HeaderAdmin);
export { connectedHeaderAdmin as HeaderAdmin };

HeaderAdmin.propTypes = {
    title: PropTypes.string.isRequired,
};

const Body = styled.div`
    height: 64px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 32px;
    padding: 0 20px;

    background-color: #26CFA9;
    color: #fff;

    position: relative;
`;
const Logo = styled.img`
    width: 208px;
    height: 32px;
    background-color: #fff;
`;

const Title = styled.div`
    font-size: 24px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const Button = styled.div`
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    i {
        font-size: 32px;
        margin-right: 10px;
    }
`;
